import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { CANNED_RESOURCE_ACTIONS } from "components/dashboard/TrainSAM/CannedResponses/enum";
import { baseResourceActions, baseResources } from "routes/enum";

const { DELETE_CANNED_RESOURCE, VIEW_CANNED_RESOURCE } =
    CANNED_RESOURCE_ACTIONS;

const { KB_AGENT_GUIDE } = baseResources;
const { READ, UPDATE } = baseResourceActions;

const UpdatesTableDropdown = ({ handleModalAction, hideView, updateResource }) => {
    const options = hideView
        ? [
              {
                  value: DELETE_CANNED_RESOURCE,
                  label: "Delete",
                  baseResources: [`${UPDATE}_${updateResource}`],
              },
          ]
        : [
              {
                  value: VIEW_CANNED_RESOURCE,
                  label: "View",
                  baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
              },
              {
                  value: DELETE_CANNED_RESOURCE,
                  label: "Delete",
                  baseResources: [`${UPDATE}_${updateResource}`],
              },
          ];
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleModalAction?.(value)}
            options={options}
        />
    );
};

export default UpdatesTableDropdown;
